import { render } from "./Orders-page.vue?vue&type=template&id=1fa32d40"
import script from "./Orders-page.vue?vue&type=script&lang=js"
export * from "./Orders-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__